import { useApiQuery } from '../../hooks/use-api';

export interface Client {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  isActive: boolean;
}

export interface ClientListResponse {
  clients: Client[];
  pagination: {
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
  };
}

export function useClientList(page: number = 1, pageSize: number = 20) {
  const endpoint = `/clients?page=${page}&pageSize=${pageSize}`;
  return useApiQuery<ClientListResponse>(['clients', JSON.stringify({ page, pageSize })], endpoint);
}